import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../../../_metronic/_partials/controls";
import {toast} from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";
import * as actions from "../../_redux/partner-quota-action"
import { useHistory } from "react-router-dom";

export const PartnerQuotaHistoryMain = ({}) => {
  const history = useHistory();
  
  const {entities, groupEntities, error} = useSelector((state) => state.partnerQuota)
  
  const dispatch = useDispatch()
  
  useEffect(() => {
    if(entities instanceof Array && groupEntities instanceof Array) {
      const [mainGrouped = {}] = groupEntities;
      const [latestHistory = {}] = entities;

      const initialFormValue = {
        thk_partner_uuid: mainGrouped.partner_uuid,
        thk_livestock_uuid: mainGrouped.livestock_uuid,
        thk_area_uuid: mainGrouped.area_uuid,
        thk_partner: {},
        thk_livestock: {},
        thk_area: {},
        price: latestHistory.price,
        qty: latestHistory.qty,
      }

      initialFormValue.thk_partner = {
        uuid: initialFormValue.thk_partner_uuid,
        name: mainGrouped.partner_name,
      }
      initialFormValue.thk_livestock = {
        uuid: initialFormValue.thk_livestock_uuid,
        name: mainGrouped.livestock_name,
      }
      initialFormValue.thk_area = {
        uuid: initialFormValue.thk_area_uuid,
        name: mainGrouped.area_name,
      }

      dispatch(actions.setInitialFormValue(initialFormValue));
    }
  }, [entities, groupEntities]);
  
  if(error) {
    toast.error(error, toastOption)
  }
  
  const columns = [
    {
      dataField: "partner_name",
      text: "Mitra",
      sort: true,
    },
    {
      dataField: "livestock_name",
      text: "Hewan",
      sort: true,
    },
    {
      dataField: "area_name",
      text: "Wilayah",
      sort: true,
    },
    {
      dataField: "quota",
      text: "Kuota",
      sort: true,
    },
    {
      dataField: "distributed",
      text: "Terdistribusi",
      sort: true,
    },
    {
      dataField: "remaining",
      text: "Sisa",
      sort: true,
    }
  ];

  return (
    <Card>
      <CardHeader title="Kuota Mitra">
        <CardHeaderToolbar>
          <div className="d-flex">
            <button className="btn btn-primary mr-3" onClick={() => history.push("/kurban/quota-partner/new")}>Edit Kuota</button>
            <button className="btn btn-secondary" onClick={() => history.goBack()}>Kembali</button>
          </div>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <BootstrapTable
          wrapperClasses="table-responsive"
          classes="table table-head-custom table-vertical-center overflow-hidden"
          bootstrap4
          bordered={false}
          remote
          keyField="uuid"
          data={groupEntities ?? []}
          columns={columns}          
        />
      </CardBody>
    </Card>
  );
}
